import { backofficeAppConfig } from '@/backoffice/app/config/backoffice-app-config';
import { TAppConfig } from '@/shared/features/app-config/context/app-config-context.types';
import {
  useReadAllResourceGroupsQuery,
  useReadResourceGroupsForSelectQuery,
  useReadResourceGroupByIdQuery,
  useReadResourceGroupNameByIdQuery,
  useReadResourceGroupNamesForRoleRowQuery,
  useReadSubGroupsForResourceGroupQuery,
  useLazyReadResourceGroupNameByIdQuery,
} from '@/shared/redux/api/assets/groups/enhanced-groups-api';
import {
  useReadAllRolesQuery,
  useReadAllUsersBaseQuery,
  useReadAllUsersQuery,
  useReadUsersForSelectQuery,
  useReadRoleQuery,
  useReadRolesForSelectQuery,
  useReadUserQuery,
  useReadUserRoleLinksForRoleQuery,
  useReadUserRoleLinksForUserQuery,
  useReadUsersForRoleQuery,
} from '@/shared/redux/api/ident/enhanced-ident-api';

// On tenant-inner pages the super-user impersonates the tenant (custom token).
// We keep the backoffice config for everything (permissions, mutations,
// selectors) but route the config-backed *read* hooks to the shared console
// implementations, which run on acceptCustomToken=true base APIs — so user /
// role / group lookups (e.g. audit-log actors) resolve the impersonated
// tenant's data instead of the super-tenant's. Mutations stay on backoffice.
export const tenantInnerAppConfig: TAppConfig = {
  ...backofficeAppConfig,
  rbac: {
    ...backofficeAppConfig.rbac,
    api: {
      ...backofficeAppConfig.rbac.api,
      useReadAllRolesQuery,
      useReadRolesForSelectQuery,
      useReadRoleQuery,
      useReadAllUsersBaseQuery,
      useReadAllUsersQuery,
      useReadUsersForSelectQuery,
      useReadUserQuery,
      useReadUsersForRoleQuery,
      useReadUserRoleLinksForUserQuery,
      useReadUserRoleLinksForRoleQuery,
    },
  },
  groups: {
    ...backofficeAppConfig.groups,
    api: {
      ...backofficeAppConfig.groups.api,
      useReadAllResourceGroupsQuery,
      useReadResourceGroupsForSelectQuery,
      useReadResourceGroupByIdQuery,
      useReadResourceGroupNameByIdQuery,
      useLazyReadResourceGroupNameByIdQuery,
      useReadResourceGroupNamesForRoleRowQuery,
      useReadSubGroupsForResourceGroupQuery,
    },
  },
};
